//api/orders/{order_id}/

import axios from "./configAxios";

export const getOrderDetails = async (order_id) => {
    return await axios.get(`/${order_id}/`)
}